var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['v-ribbon', ("v-ribbon--" + _vm.position)]},[_c('v-text',{class:[
      'v-ribbon__rotate',
      'text-white',
      ("bg-" + _vm.color)
    ],attrs:{"bold":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }